export { default } from "./ClaimProcess.gql";
